import React from 'react';
import PropTypes from 'prop-types';
import FormattedText from '../../../components/01_atoms/FormattedText';
import TableOfContents from '../../TableOfContents';

import styles from './index.module.scss';

const BBTextWithTableContent = ({ text }) => {
  const tableOfContents = [];
  // Assign html ids to heading tags and add an item for each heading into
  // tableOfContents array.
  const content = text.replace(/<h(\d)>(.+?)<\/h\d>/gi, (match, p1, p2) => {
    const id = `ref${tableOfContents.length + 1}`;
    tableOfContents.push({ id, label: p2 });
    return `<h${p1} id="${id}">${p2}</h${p1}>`;
  });

  return (
    <div className={`bb ${styles['bb-text-with-table-content']}`}>
      <div className="container">
        <TableOfContents tableOfContents={tableOfContents} />
        <FormattedText text={content} />
      </div>
    </div>
  );
};

BBTextWithTableContent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BBTextWithTableContent;
